import { mutatorAction } from 'satcheljs';
import { connectedAccountsStore } from '../../store/store';
export var updateBasicPassword = mutatorAction('updateBasicPassword', function (password) {
    var store = connectedAccountsStore();
    store.connectBasicState.password = password;
});
//# sourceMappingURL=updateBasicPassword.js.map